import { WithStyles, withStyles } from '@mui/styles';

import { ACGNumbersPage } from './ACGNumber';
import { muiStyles } from './ACGNumberStyles';

export interface IAcgPageProps extends WithStyles<typeof muiStyles>{
    location: any;
    setCurrentPage: () => void;
}

export default withStyles(muiStyles)(ACGNumbersPage);